import React from "react";

export type TooltipState = {
    x: number;
    y: number;
    containerWidth: number;
    title: string;
    rows: { label: string; value: number; tone?: "good" | "bad" }[];
};

const TIP_WIDTH = 190;

const ChartTooltip: React.FC<{ tip: TooltipState }> = ({ tip }) => {
    // Flip to the left of the cursor if it would overflow the chart's right edge.
    const left =
        tip.x + 18 + TIP_WIDTH > tip.containerWidth
            ? tip.x - TIP_WIDTH - 14
            : tip.x + 18;

    return (
        <div className="po-tooltip" style={{ left, top: tip.y + 12, width: TIP_WIDTH }}>
            <div className="po-tooltip__title">{tip.title}</div>
            {tip.rows.map((r) => (
                <div className={`po-tooltip__row ${r.tone ?? ""}`} key={r.label}>
                    {r.label} : {r.value.toLocaleString("en-US")}
                </div>
            ))}
        </div>
    );
};

export default ChartTooltip;
